import PageManagerContainer from './page-manager-container';
import NewPageDialogContainer from './new-page-dialog-container';
import CreateFolderDialogContainer from './create-folder-dialog-container';
import FolderSettingsDialogContainer from './folder-settings-dialog-container';
import FolderDeleteContainer from './folder-delete-container';
import PageDeleteContainer from './page-delete-container';
import PageButtonContainer from './page-button-container';
import BulkEditingDeleteContainer from './bulk-editing-delete-container';
import BulkEditingMoveToDialogContainer from './bulk-editing-move-to-dialog-container';

export default {
  PageManagerContainer,
  NewPageDialogContainer,
  CreateFolderDialogContainer,
  FolderSettingsDialogContainer,
  FolderDeleteContainer,
  PageDeleteContainer,
  PageButtonContainer,
  BulkEditingDeleteContainer,
  BulkEditingMoveToDialogContainer,
};
